/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/button-has-type */
// eslint-disable-next-line jsx-a11y/label-has-associated-control
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { toast, ToastContainer } from 'react-toastify';
import { useAuth } from '../../hooks/auth/useAuth';

// eslint-disable-next-line react/prop-types
const ResetPassword = ({ match, history }) => {
  // eslint-disable-next-line react/prop-types
  const { token } = match.params;

  const { onResetChange, resetPassword, reset, isLoading } = useAuth();

  const changePassword = (data) => {
    if (data.password !== data.confirm) {
      toast.info('Passwords do not match!');
    } else {
      resetPassword(data, token, history);
    }
  };

  const showSubmitButton = () => {
    if (isLoading) {
      return (
        <button className="btn btn-grey w-50" disabled={isLoading}>
          Resetting...
        </button>
      );
    }

    return (
      <button
        className="btn btn-grey w-50"
        onClick={() => changePassword(reset)}
      >
        RESET
      </button>
    );
  };

  const { password, confirm } = reset;

  return (
    <span>
      <div className="container">
        <div className="row mt-5">
          <div className="col-12 text-center col-md-5 ml-auto mr-auto">
            <div className="ghana-logo">
              <img src="images/GhanWifi Logo.png" alt="" />
            </div>

            <div className="form-horizontal col-md-12">
              <div className="form-group text-left">
                <label className="welcome-back">New Password</label>
                <input
                  type="password"
                  name="password"
                  value={password}
                  onChange={onResetChange}
                  className="form-control"
                  placeholder="New Password"
                />
              </div>

              <div className="form-group text-left">
                <label className="welcome-back">Confirm Password</label>
                <input
                  type="password"
                  name="confirm"
                  value={confirm}
                  onChange={onResetChange}
                  className="form-control"
                  placeholder="Confirm Password"
                />
              </div>
            </div>
            <div className="form-group">
              {showSubmitButton()}
              <p className="mt-3">
                Ready to
                <Link to="/login">Login</Link>?{' '}
              </p>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </span>
  );
};

ResetPassword.proptype = {
  match: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
};

export default ResetPassword;
